<template>
    <zen-one
        :showuserinfo="false"
        :crumbs="crumbs"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
    >
        <z-page title="Bayaran Balik Bantuan - Butiran">
            <w-card bg-color="" class="">
                <w-flex>
                    <div class="xs6 mr5">
                        <h5 class="fw-semibold m0">No. Rujukan Subsidiari :</h5>
                        <div class="fw-normal my1 fs-1">
                            {{ form.no_rujukan }}
                        </div>
                    </div>

                    <div class="xs6 mr5">
                        <h5 class="fw-semibold m0">Skim Bantuan :</h5>
                        <div class="fw-normal my1 fs-1">
                            {{ form.skim_keterangan }}
                        </div>
                    </div>
                </w-flex>

                <w-flex>
                    <div class="xs6 mr5">
                        <h5 class="fw-semibold m0">Nama :</h5>
                        <div class="fw-normal my1 fs-1">
                            {{ form.nama }}
                        </div>
                    </div>

                    <div class="xs6 mr5">
                        <h5 class="fw-semibold m0">No. Kad Pengenalan :</h5>
                        <div class="fw-normal my1 fs-1">
                            {{ form.no_id }}
                        </div>
                    </div>
                </w-flex>

                <w-flex>
                    <div class="xs6 mr5">
                        <h5 class="fw-semibold m0">Nama Waris :</h5>
                        <div class="fw-normal my1 fs-1">
                            {{ form.nama_waris }}
                        </div>
                    </div>

                    <div class="xs6 mr5">
                        <h5 class="fw-semibold m0">
                            No. Kad Pengenalan Pewaris :
                        </h5>
                        <div class="fw-normal my1 fs-1">
                            {{ form.no_id_waris }}
                        </div>
                    </div>
                </w-flex>

                <w-flex>
                    <div class="xs6 mr5">
                        <h5 class="fw-semibold m0">
                            Tarikh Laporan Diterima :
                        </h5>
                        <div class="fw-normal my1 fs-1">
                            {{ $zutil.dateformat(form.tarikh_laporan) }}
                        </div>
                    </div>
                    <div class="xs6 mr5">
                        <h5 class="fw-semibold m0">Tarikh Meninggal Dunia :</h5>
                        <div class="fw-normal my1 fs-1">
                            {{ $zutil.dateformat(form.tarikh_meninggal) }}
                        </div>
                    </div>
                </w-flex>

                <w-flex>
                    <div class="xs6 mr5">
                        <h5 class="fw-semibold m0">Tempoh Tunggakan :</h5>
                        <div class="fw-normal my1 fs-1">
                            {{ $zutil.dateformat(form.tunggakan_dari) }}
                        </div>
                    </div>
                    <div class="xs6 mr5">
                        <h5 class="fw-semibold m0">Hingga :</h5>
                        <div class="fw-normal my1 fs-1">
                            {{ $zutil.dateformat(form.tunggakan_hingga) }}
                        </div>
                    </div>
                </w-flex>

                <w-flex>
                    <div class="xs6 mr5">
                        <h5 class="fw-semibold m0">Jumlah Tunggakan (RM) :</h5>
                        <div class="fw-normal my1 fs-1">
                            {{ $zutil.currency(form.amaun_tunggakan) }}
                        </div>
                    </div>

                    <div class="xs6 mr5">
                        <h5 class="fw-semibold m0">Perihal Tunggakan :</h5>
                        <div class="fw-normal my1 fs-1">
                            {{ form.perihal_keterangan }}
                        </div>
                    </div>
                </w-flex>

                <w-flex>
                    <div class="xs6 mr5">
                        <h5 class="fw-semibold m0">
                            Jumlah Bantuan Bulanan (RM) :
                        </h5>
                        <div class="fw-normal my1 fs-1">
                            {{ form.amaun_bulanan }}
                        </div>
                    </div>

                    <div class="xs6 mr5">
                        <h5 class="fw-semibold m0">Perihal Catatan :</h5>
                        <div class="fw-normal my1 fs-1">
                            {{ form.catatan }}
                        </div>
                    </div>
                </w-flex>

                <w-flex>
                    <div class="xs6 mr5">
                        <h5 class="fw-semibold m0">Status :</h5>
                        <div class="fw-normal my1 fs-1">
                            {{ form.status_keterangan }}
                        </div>
                    </div>

                    <div class="xs6 mr5"></div>
                </w-flex>

                <template v-if="form.lkp_inbois_status_id == 3">
                    <w-flex justify-center align-center>
                        <div class="xs4">
                            <h5 class="fw-semibold m0">No. Resit :</h5>
                            <div class="fw-normal my1 fs-1">
                                {{ form.no_resit }}
                            </div>
                        </div>
                        <div class="xs4">
                            <h5 class="fw-semibold m0">No. Rujukan :</h5>
                            <div class="fw-normal my1 fs-1">
                                {{ form.no_rujukan }}
                            </div>
                        </div>
                        <div class="xs4">
                            <h5 class="fw-semibold m0">Cara Bayaran :</h5>
                            <div class="fw-normal my1 fs-1">
                                {{ form.cara_bayaran }}
                            </div>
                        </div>
                    </w-flex>
                    <w-flex justify-left align-left>
                        <div class="xs4">
                            <h5 class="fw-semibold m0">Tarikh Bayar :</h5>
                            <div class="fw-normal my1 fs-1">
                                {{ form.tarikh_bayar }}
                            </div>
                        </div>
                    </w-flex>
                </template>
            </w-card>

            <center v-if="loading">
                <w-progress class="ma1" circle></w-progress>
            </center>

            <w-tabs
                :items="tabs"
                :no-slider="false"
                active-class="primary"
                v-model="activeTab"
            >
                <!-- TAB TRANSAKSI -->
                <template #item-content.1>
                    <w-flex class="mt1 mb3" justify-end>
                        <div class="mt2 text-right">
                            <w-button
                                class="ml1"
                                @click="cetak"
                                bg-color="success"
                            >
                                <w-icon>fal fa-print</w-icon>&nbsp;Cetak
                            </w-button>
                        </div>
                    </w-flex>
                    <w-flex justify-center align-center>
                        <div class="w-card__content content-hardcode">
                            <table class="table-dashboard" width="100%">
                                <thead>
                                    <tr>
                                        <td>Tarikh</td>
                                        <td>No Dokumen</td>
                                        <td>Perihal</td>
                                        <td>Keterangan</td>
                                        <td>Bilangan Dokumen</td>
                                        <td>Tarikh Dokumen</td>
                                        <td>Tarikh Tamat Surat</td>
                                        <td>Amaun Debit (RM)</td>
                                        <td>Amaun Kredit (RM)</td>
                                        <td>Baki (RM)</td>
                                    </tr>
                                </thead>
                                <tbody style="text-align: center">
                                    <tr
                                        v-for="(value, index) in form.transaksi"
                                    >
                                        <td>{{ value.tarikh_transaksi }}</td>
                                        <td>{{ value.no_rujukan }}</td>
                                        <td>
                                            {{ value.transaksi_keterangan }}
                                        </td>
                                        <td>
                                            {{
                                                form.jejak_audit[index - 1]
                                                    ? form.jejak_audit[
                                                          index - 1
                                                      ].catatan
                                                    : "-"
                                            }}
                                        </td>
                                        <td>
                                            {{ value.bil_dokumen }}
                                        </td>
                                        <td>
                                            {{
                                                $zutil.dateformat(
                                                    value.tarikh_dokumen
                                                )
                                            }}
                                        </td>
                                        <td>
                                            {{
                                                $zutil.dateformat(
                                                    value.tarikh_tamat_surat
                                                )
                                            }}
                                        </td>
                                        <td align="right">
                                            {{
                                                $zutil.currency(
                                                    value.amaun_debit
                                                )
                                            }}
                                        </td>
                                        <td align="right">
                                            {{
                                                $zutil.currency(
                                                    value.amaun_kredit
                                                )
                                            }}
                                        </td>

                                        <td align="right">
                                            {{
                                                $zutil.currency(
                                                    value.amaun_baki
                                                )
                                            }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </w-flex>

                    <w-flex class="mt3" wrap align-center justify-end>
                        <w-button
                            class="my1"
                            bg-color="warning"
                            dark
                            @click="back()"
                            >Kembali</w-button
                        >
                    </w-flex>
                </template>
                <!-- TAB LAMPIRAN -->
                <template #item-content.2>
                    <w-flex justify-center align-center>
                        <div class="w-card__content content-hardcode">
                            <table class="table-dashboard" width="100%">
                                <thead>
                                    <tr>
                                        <td width="2%">No</td>
                                        <td>Lampiran</td>
                                        <td width="15%">Tarikh</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(dt, index) in form.lampir">
                                        <td class="w-table__cell text-left">
                                            {{ index + 1 }}
                                        </td>
                                        <td class="w-table__cell text-left">
                                            <a :href="dt.url"> {{ dt.nama }}</a>
                                        </td>
                                        <td class="w-table__cell text-left">
                                            {{
                                                $zutil.dateformat(dt.created_at)
                                            }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </w-flex>
                </template>

                <!-- TAB TINDAKAN -->
                <template #item-content.3>
                    <!--  <w-form
            class=""
            v-model="form.valid"
            v-model:errors-count="form.errorsCount"
            @validate="onValidate"
            @success="send"
        > -->
                    <w-form
                        class=""
                        v-model="form.valid"
                        v-model:errors-count="form.errorsCount"
                        @validate="onValidate"
                        @success="onSuccess"
                    >
                        <w-flex>
                            <div class="xs3">
                                <h5 class="fw-semibold m0">Tindakan *</h5>
                            </div>
                            <div class="xs9">
                                <template v-if="form.transaksi">
                                    <z-lookup
                                        label="Tindakan"
                                        name="jenis_transaksi"
                                        :url="
                                            service_tunggakan +
                                            'lookup/lkp_tuntutan_bantuan_transaksi'
                                        "
                                        :sort="false"
                                        :cache="false"
                                        v-model="
                                            form.lkp_tuntutan_bantuan_transaksi_id
                                        "
                                    />
                                </template>
                                <!-- <template v-else>
                                    <z-lookup
                                        label="Jenis Tindakan *"
                                        name="jenis_transaksi"
                                        :url="
                                            service_tunggakan +
                                            'lookup/lkp_tuntutan_bantuan_transaksi_kira'
                                        "
                                        :sort="false"
                                        :cache="false"
                                        v-model="
                                            form.lkp_tuntutan_bantuan_transaksi_id
                                        "
                                    />
                                </template> -->
                            </div>
                        </w-flex>
                        <div style="margin-bottom: 10px"></div>
                        <!-- Add space here -->
                        <template
                            v-if="form.lkp_tuntutan_bantuan_transaksi_id == 3"
                        >
                            <w-flex>
                                <div class="xs3">
                                    <h5 class="fw-semibold m0">
                                        No. Rujukan *
                                    </h5>
                                </div>
                                <div class="xs9">
                                    <w-input
                                        v-model="form.add_no_rujukan"
                                        required
                                        outline
                                        placeholder="Sila Masukkan"
                                        :validators="[validators.required]"
                                    >
                                    </w-input>
                                </div>
                            </w-flex>
                            <br />
                            <w-flex>
                                <div class="xs3">
                                    <h5 class="fw-semibold m0">
                                        Amaun Tunggakan (RM) :
                                    </h5>
                                </div>
                                <div class="xs9">
                                    {{ $zutil.currency(form.amaun_tunggakan) }}
                                </div>
                            </w-flex>
                            <br />
                            <w-flex
                                v-if="
                                    form.lkp_tuntutan_bantuan_transaksi_id == 3
                                "
                            >
                                <div class="xs3">
                                    <h5 class="fw-semibold m0">
                                        Amaun Pelarasan (RM) * :
                                    </h5>
                                </div>
                                <div class="xs9">
                                    <table width="100%">
                                        <thead>
                                            <tr>
                                                <td>Akaun</td>
                                                <td>Debit(RM)</td>
                                                <td>
                                                    <w-icon @click="addItem1"
                                                        >fal fa-plus</w-icon
                                                    >
                                                </td>
                                            </tr>
                                        </thead>
                                        <br />
                                        <tr v-for="(dt, index) in butiran">
                                            <td>
                                                <z-lookup
                                                    class="mb4"
                                                    :url="
                                                        service_deposit +
                                                        'lookup/akaun_akhir'
                                                    "
                                                    :sort="false"
                                                    :cache="false"
                                                    v-model="dt.akaun_id"
                                                    :validators="[
                                                        validators.required,
                                                    ]"
                                                >
                                                </z-lookup>
                                            </td>
                                            <td>
                                                <z-money
                                                    class="mb4"
                                                    v-model:originalValue="
                                                        dt.amaun_debit
                                                    "
                                                    v-on:keyup="totalAmaun()"
                                                    validators="[validators.required]"
                                                ></z-money>
                                                <!-- <div
                                                    class="w-form-el__error error"
                                                    v-if="form.amaun_baki < 0"
                                                    style=""
                                                >
                                                    Baki Tidak bole kurang
                                                </div> -->
                                            </td>
                                            <w-icon
                                                class="mr1"
                                                @click="removeItem3(index)"
                                                >fal fa-trash</w-icon
                                            >
                                        </tr>
                                    </table>
                                </div>
                            </w-flex>
                            <br />
                            <br />
                            <w-flex
                                v-if="
                                    form.lkp_tuntutan_bantuan_transaksi_id == 3
                                "
                            >
                                <div class="xs3">
                                    <h5 class="fw-semibold m0">Amaun (RM) :</h5>
                                </div>
                                <div class="xs9">
                                    {{ $zutil.currency(form.amaun) }}
                                </div>
                            </w-flex>
                            <template
                                v-if="
                                    form.lkp_tuntutan_bantuan_transaksi_id == 3
                                "
                            >
                                <w-flex>
                                    <div class="xs3">
                                        <br />
                                        <h5 class="fw-semibold m0">
                                            Baki Akhir (RM) :
                                        </h5>
                                    </div>
                                    <div class="xs9">
                                        <br />
                                        {{ $zutil.currency(form.amaun_baki) }}
                                    </div> </w-flex
                                ><br />
                            </template>
                            <w-flex>
                                <div class="xs3">
                                    <h5 class="fw-semibold m0">Keterangan *</h5>
                                </div>
                                <div class="xs9">
                                    <w-textarea
                                        class="mb3"
                                        label-position="left"
                                        outline
                                        v-model="form.keterangan"
                                        :validators="[validators.required]"
                                    >
                                    </w-textarea>
                                </div>
                            </w-flex>
                            <w-flex>
                                <div class="xs3">
                                    <h5 class="fw-semibold m0">
                                        Dokumen sokongan :
                                    </h5>
                                </div>
                                <div class="xs9">
                                    <a :href="form.url">
                                        {{ form.name }}
                                    </a>

                                    <!-- <template v-if="form.lampiran_fail == null"> -->
                                    <w-input
                                        class="mt3"
                                        outline
                                        type="file"
                                        v-model="files"
                                    >
                                    </w-input>
                                    <!--  </template>
                    <template v-else>
                        <w-input
                            readonly
                            class="mt3"
                            outline
                        >
                        </w-input>
                    </template> -->
                                </div>
                            </w-flex>
                            <br />
                        </template>
                        <template
                            v-else-if="
                                form.lkp_tuntutan_bantuan_transaksi_id == 5
                            "
                        >
                            <w-flex>
                                <div class="xs3">
                                    <h5 class="fw-semibold m0">No. Dokumen</h5>
                                </div>
                                <div class="xs9">
                                    <w-input
                                        v-model="form.add_no_rujukan"
                                        required
                                        outline
                                        placeholder="Sila Masukkan"
                                        :validators="[validators.notrequired]"
                                    >
                                    </w-input>
                                </div>
                            </w-flex>
                            <br />
                            <w-flex>
                                <div class="xs3">
                                    <h5 class="fw-semibold m0">
                                        Amaun Tunggakan (RM) :
                                    </h5>
                                </div>
                                <div class="xs9">
                                    {{ $zutil.currency(form.amaun_tunggakan) }}
                                </div>
                            </w-flex>
                            <br />
                            <w-flex>
                                <div class="xs3">
                                    <h5 class="fw-semibold m0">
                                        Amaun Hapus Kira (RM) *
                                    </h5>
                                </div>
                                <div class="xs9">
                                    <z-money
                                        v-on:keyup="cekJumlah3(form)"
                                        v-model:originalValue="
                                            form.amaun_transaksi
                                        "
                                        validators="[validators.required]"
                                    ></z-money>
                                    <!-- <div class="w-form-el__error error" v-if="form.amaun > form.amaun_belum_inbois" style="">
                               Amaun Melebihi {{$zutil.currency(form.amaun_belum_inbois)}}
                               </div> -->
                                </div>
                            </w-flex>
                            <br />
                            <br v-if="form.lkp_deposit_trans_id" />
                            <w-flex>
                                <div class="xs3">
                                    <h5 class="fw-semibold m0">Amaun (RM) :</h5>
                                </div>
                                <div class="xs9">
                                    {{ $zutil.currency(form.amaun_transaksi) }}
                                </div>
                            </w-flex>
                            <template
                                v-if="
                                    form.lkp_tuntutan_bantuan_transaksi_id == 5
                                "
                            >
                                <w-flex>
                                    <div class="xs3">
                                        <br />
                                        <h5 class="fw-semibold m0">
                                            Baki Akhir (RM) :
                                        </h5>
                                    </div>
                                    <div class="xs9">
                                        <br />
                                        {{ $zutil.currency(form.baki_akhir) }}
                                    </div> </w-flex
                                ><br />
                            </template>

                            <w-flex>
                                <div class="xs3">
                                    <h5 class="fw-semibold m0">Keterangan *</h5>
                                </div>
                                <div class="xs9">
                                    <w-textarea
                                        class="mb3"
                                        label-position="left"
                                        outline
                                        v-model="form.keterangan"
                                        :validators="[validators.required]"
                                    >
                                    </w-textarea>
                                </div>
                            </w-flex>
                            <w-flex>
                                <div class="xs3">
                                    <h5 class="fw-semibold m0">
                                        Dokumen sokongan :
                                    </h5>
                                </div>
                                <div class="xs9">
                                    <a :href="form.url">
                                        {{ form.name }}
                                    </a>

                                    <!-- <template v-if="form.lampiran_fail == null"> -->
                                    <w-input
                                        class="mt3"
                                        outline
                                        type="file"
                                        v-model="files"
                                    >
                                    </w-input>
                                    <!--  </template>
                    <template v-else>
                        <w-input
                            readonly
                            class="mt3"
                            outline
                        >
                        </w-input>
                    </template> -->
                                </div>
                            </w-flex>
                            <br />
                        </template>
                        <template
                            v-else-if="
                                form.lkp_tuntutan_bantuan_transaksi_id == 4
                            "
                        >
                            <w-flex>
                                <div class="xs3">
                                    <h5 class="fw-semibold m0">
                                        Bayaran Ke *:
                                    </h5>
                                </div>
                                <div class="xs9">
                                    <w-radios
                                        v-model="form.profil_bayaran"
                                        :items="bayaran_balik"
                                        inline
                                    ></w-radios>
                                </div>
                            </w-flex>
                            <br /><w-flex>
                                <div class="xs3">
                                    <h5 class="fw-semibold m0">
                                        Amaun Tunggakan (RM) :
                                    </h5>
                                </div>
                                <div class="xs9">
                                    {{ $zutil.currency(form.amaun_tunggakan) }}
                                </div> </w-flex
                            ><br />
                            <template v-if="form.profil_bayaran == 1">
                                <w-flex>
                                    <div class="xs3">
                                        <h5 class="fw-semibold m0">
                                            Amaun (RM)* :
                                        </h5>
                                    </div>
                                    <div class="xs9">
                                        <z-money
                                            class="mb4"
                                            v-on:keyup="cekJumlah2(form)"
                                            v-model:originalValue="
                                                form.amaun_pembayar
                                            "
                                            validators="[validators.required]"
                                        ></z-money>
                                    </div>
                                </w-flex>
                                <w-flex>
                                    <div class="xs3">
                                        <h5 class="fw-semibold m0">Bank * :</h5>
                                    </div>
                                    <div class="xs9">
                                        <z-lookup
                                            name="Bank"
                                            :url="
                                                service_utiliti + 'lookup/bank'
                                            "
                                            :sort="false"
                                            :cache="false"
                                            outline
                                            v-model="form.lkp_bank_id"
                                            :validators="[validators.required]"
                                        />
                                    </div> </w-flex
                                ><br />
                                <w-flex>
                                    <div class="xs3">
                                        <h5 class="fw-semibold m0">
                                            No Akaun Bank * :
                                        </h5>
                                    </div>
                                    <div class="xs9">
                                        <w-input
                                            v-model="form.no_akaun"
                                            required
                                            outline
                                            placeholder="Sila Masukkan No Akaun Bank"
                                            :validators="[validators.required]"
                                        >
                                        </w-input>
                                    </div>
                                </w-flex>
                            </template>
                            <template v-if="form.profil_bayaran == 2">
                                <div class="w-card__content content-hardcode">
                                    <table class="table-dashboard" width="100%">
                                        <thead>
                                            <tr>
                                                <td>Nama Penerima Bayaran *</td>
                                                <td>Bank Penerima Bayaran *</td>
                                                <td>
                                                    No. Akaun Penerima Bayaran *
                                                </td>
                                                <td>Catatan</td>
                                                <td>Amaun Bayaran (RM) *</td>
                                                <td>
                                                    <w-icon
                                                        class="mr1"
                                                        @click="addBayaran"
                                                        >fal fa-plus</w-icon
                                                    >
                                                </td>
                                            </tr>
                                        </thead>
                                        <br />
                                        <tbody>
                                            <tr
                                                v-for="(
                                                    val, index
                                                ) in bayaran_lain_lain"
                                            >
                                                <td>
                                                    <z-input
                                                        v-model="
                                                            val.bayaran_profil_keterangan
                                                        "
                                                        name="profil_id"
                                                        :validators="[
                                                            validators.required,
                                                        ]"
                                                    />
                                                </td>
                                                <td>
                                                    <z-lookup
                                                        name="akaun"
                                                        :url="
                                                            service_utiliti +
                                                            'lookup/bank'
                                                        "
                                                        :sort="false"
                                                        :cache="false"
                                                        v-model="
                                                            val.bayaran_lkp_bank_id
                                                        "
                                                        :validators="[
                                                            validators.required,
                                                        ]"
                                                    />
                                                </td>
                                                <td>
                                                    <w-input
                                                        v-model="
                                                            val.bayaran_no_akaun
                                                        "
                                                        required
                                                        :validators="[
                                                            validators.required,
                                                        ]"
                                                    />
                                                </td>
                                                <td>
                                                    <w-input
                                                        v-model="
                                                            val.bayaran_catatan
                                                        "
                                                    />
                                                </td>
                                                <td>
                                                    <z-money
                                                        v-on:keyup="
                                                            cekJumlah2(form)
                                                        "
                                                        v-model:originalValue="
                                                            val.amaun_pembayar
                                                        "
                                                        :validators="[
                                                            validators.required,
                                                        ]"
                                                    />
                                                </td>
                                                <td>
                                                    <w-icon
                                                        class="mr1"
                                                        @click="
                                                            removeBayaran(index)
                                                        "
                                                        >fal fa-trash</w-icon
                                                    >
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </template>
                            <br />
                            <template
                                v-if="
                                    form.lkp_tuntutan_bantuan_transaksi_id == 4
                                "
                            >
                                <w-flex>
                                    <div class="xs3">
                                        <br />
                                        <h5 class="fw-semibold m0">
                                            Baki Akhir (RM) :
                                        </h5>
                                    </div>
                                    <div class="xs9">
                                        <br />
                                        {{ $zutil.currency(form.baki_akhir) }}
                                    </div> </w-flex
                                ><br />
                            </template>

                            <w-flex>
                                <div class="xs3">
                                    <h5 class="fw-semibold m0">Keterangan *</h5>
                                </div>
                                <div class="xs9">
                                    <w-textarea
                                        class="mb3"
                                        label-position="left"
                                        outline
                                        v-model="form.keterangan"
                                        :validators="[validators.required]"
                                    >
                                    </w-textarea>
                                </div>
                            </w-flex>
                            <w-flex>
                                <div class="xs3">
                                    <h5 class="fw-semibold m0">
                                        Dokumen sokongan :
                                    </h5>
                                </div>
                                <div class="xs9">
                                    <a :href="form.url">
                                        {{ form.name }}
                                    </a>
                                    <w-input
                                        class="mt3"
                                        outline
                                        type="file"
                                        v-model="files"
                                    >
                                    </w-input>
                                </div>
                            </w-flex>
                            <br />
                        </template>
                        <template
                            v-if="form.lkp_tuntutan_bantuan_transaksi_id == 6"
                        >
                            <w-flex>
                                <div class="xs3">
                                    <h5 class="fw-semibold m0">
                                        No. Dokumen *
                                    </h5>
                                </div>
                                <div class="xs9">
                                    <w-input
                                        v-model="form.add_no_rujukan"
                                        required
                                        outline
                                        placeholder="Sila Masukkan"
                                        :validators="[validators.required]"
                                    >
                                    </w-input>
                                </div>
                            </w-flex>
                            <br />
                            <w-flex>
                                <div class="xs3">
                                    <h5 class="fw-semibold m0">
                                        Tarikh Dokumen
                                    </h5>
                                </div>
                                <div class="xs4">
                                    <w-input
                                        v-model="form.tarikh_dokumen"
                                        required
                                        type="date"
                                        outline
                                        placeholder="Sila Masukkan"
                                        :validators="[validators.required]"
                                    />
                                </div>
                                <div class="xs1"></div>
                                <div class="xs4">
                                    <w-input
                                        v-model="form.tarikh_tamat_surat"
                                        required
                                        type="date"
                                        outline
                                        placeholder="Sila Masukkan"
                                        :validators="[validators.required]"
                                    />
                                </div>
                            </w-flex>
                            <br />

                            <w-flex>
                                <div class="xs3">
                                    <h5 class="fw-semibold m0">
                                        Bil. Surat Peringatan *
                                    </h5>
                                </div>
                                <div class="xs9">
                                    <w-radios
                                        v-model="form.bil_dokumen"
                                        :items="bilangan"
                                        inline
                                    ></w-radios>
                                </div>
                            </w-flex>
                            <br />

                            <w-flex>
                                <div class="xs3">
                                    <h5 class="fw-semibold m0">Keterangan *</h5>
                                </div>
                                <div class="xs9">
                                    <w-textarea
                                        class="mb3"
                                        label-position="left"
                                        outline
                                        v-model="form.keterangan"
                                        :validators="[validators.required]"
                                    >
                                    </w-textarea>
                                </div>
                            </w-flex>
                            <w-flex>
                                <div class="xs3">
                                    <h5 class="fw-semibold m0">
                                        Dokumen sokongan :
                                    </h5>
                                </div>
                                <div class="xs9">
                                    <a :href="form.url">
                                        {{ form.name }}
                                    </a>

                                    <!-- <template v-if="form.lampiran_fail == null"> -->
                                    <w-input
                                        class="mt3"
                                        outline
                                        type="file"
                                        v-model="files"
                                    >
                                    </w-input>
                                    <!--  </template>
                    <template v-else>
                        <w-input
                            readonly
                            class="mt3"
                            outline
                        >
                        </w-input>
                    </template> -->
                                </div>
                            </w-flex>
                            <br />
                        </template>

                        <w-flex class="mt3" wrap align-center justify-end>
                            <w-button
                                class="my1"
                                bg-color="warning"
                                dark
                                @click="back()"
                                >Kembali</w-button
                            >
                            &nbsp;&nbsp;
                            <w-button
                                class="mr2"
                                bg-color="warning"
                                type="reset"
                                @click="clear()"
                                >Reset
                            </w-button>

                            <!-- <template v-if="form.lkp_deposit_trans_id == 1 ||form.amaun_baki < 0"> -->
                            <w-button
                                class="my1"
                                type="submit"
                                :disabled="form.valid === false"
                                :loading="form.submitted && !form.sent"
                            >
                                <w-icon dark tile class="mr2"
                                    >fal fa-paper-plane</w-icon
                                >
                                Hantar
                            </w-button>
                            <!-- </template> -->
                        </w-flex>
                    </w-form>
                </template>

                <!-- TAB JEJAK AUDIT -->
                <template #item-content.4>
                    <w-flex justify-center align-center>
                        <div class="w-card__content content-hardcode">
                            <table class="table-dashboard" width="100%">
                                <thead>
                                    <tr>
                                        <td width="2%">No</td>
                                        <td width="15%">Tarikh</td>
                                        <td>Pengguna</td>
                                        <td>Status</td>
                                        <td>Catatan</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(dt, index) in form.jejak_audit">
                                        <td>{{ index + 1 }}</td>
                                        <td>{{ dt.tarikh }}</td>
                                        <td>{{ dt.user_nama }}</td>
                                        <td>
                                            {{ dt.tuntutan_bantuan_keterangan }}
                                        </td>
                                        <td>{{ dt.catatan }}</td>
                                    </tr>
                                    <tr v-if="form.jejak_audit.length == 0">
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </w-flex>
                    <w-flex class="mt3" wrap align-center justify-end>
                        <w-button
                            class="my1"
                            bg-color="warning"
                            dark
                            @click="back()"
                            >Kembali</w-button
                        >
                    </w-flex>
                </template>
            </w-tabs>
        </z-page>
    </zen-one>
</template>

<script>
import ZResource from "@/Modules/z-resource-service";

export default {
    extends: ZResource,
    components: {},
    props: {
        id: [Array, Object, String],
    },
    data() {
        return {
            resourceurl: this.service_tunggakan + "tuntutan_bantuan",
            reload: true,
            loading: true,
            butiran: [{ akaun_id: null, amaun_debit: 0.0 }],
            bayaran: [
                {
                    value: 1,
                    label: "Debit (RM)",
                },
                {
                    value: 2,
                    label: "Kredit (RM)",
                },
            ],
            bilangan: [
                {
                    value: 1,
                    label: "1",
                },
                {
                    value: 2,
                    label: "2",
                },
                {
                    value: 3,
                    label: "3",
                },
            ],
            bayaran_balik: [
                {
                    value: 1,
                    label: "Pembayar",
                },
                {
                    value: 2,
                    label: "Lain-lain",
                },
            ],
            bayaran_lain_lain: [
                {
                    bayaran_profil_id: null,
                    bayaran_profil_keterangan: null,
                    bayaran_lkp_bank_id: null,
                    bayaran_no_akaun: null,
                    bayaran_catatan: null,
                    amaun_pembayar: null,
                },
            ],

            tabs: [
                { title: "Transaksi", content: "" },
                { title: "Lampiran", content: "" },
                { title: "Tindakan", content: "" },
                { title: "Jejak Audit", content: "" },
            ],
            activeTab: 0,
            crumbs: [
                { label: "iHasil", route: "/" },
                { label: "Bantuan Am", route: "/tuntutan_bantuan" },
                { label: "Butiran", route: "/tuntutan_bantuan" + this.id },
            ],
        };
    },
    methods: {
        addItem() {
            this.form.butiran.push({
                akaun_id: null,
                keterangan: null,
                kuantiti: null,
                kadar: null,
                amaun: null,
            });
        },

        removeItem(index) {
            this.form.butiran.splice(index, 1);
        },
        removeItem3(index) {
            this.butiran.splice(index, 1);
        },

        cekAmaun() {
            this.form.amaun = 0;
            for (var i in this.form.butiran) {
                this.form.amaun =
                    this.form.amaun + parseFloat(this.form.butiran[i].amaun);
            }
        },

        onSuccess() {
            if (this.form.valid == true) {
                this.form.butiran = this.butiran;
                this.form.bayaran_lain_lain = this.bayaran_lain_lain;
                this.$zcomm
                    .post(
                        this.resourceurl + "/hantar/" + this.form.id,
                        this.form
                    )
                    .then((res) => {
                        if (typeof this.onAfterEdit === "function") {
                            this.onAfterEdit();
                        }

                        this.getData();
                        this.activeTab = 0;
                        this.submitLoading = true;
                        this.upload(res.id);
                        this.$inertia.visit(this.route("bantuan.show"));
                    })
                    .catch((err) => {})
                    .finally(() => {
                        this.form.loading = false;
                    });
            }
        },
        upload(id) {
            let formData = new FormData();
            formData.append("file", this.files[0].file);
            formData.append("model", "App\\Models\\TuntutanBantuan");
            formData.append("model_id", id);
            this.$zcomm
                .post(this.resourceurl + "/upload", formData)
                .then((res) => {
                    if (typeof this.onAfterAdd === "function") {
                        this.onAfterAdd();
                    }
                    this.$zutil.notify("Rekod telah berjaya dihantar");

                    this.getData();
                    this.activeTab = 0;
                    this.submitLoading = true;
                    this.$inertia.visit(this.route("bantuan.show"));
                    // this.$inertia.visit(this.$route('pendidikan.index'));
                })
                .catch((err) => {})
                .finally(() => {});
        },

        totalAmaun() {
            this.form.amaun = 0;
            for (var i in this.butiran) {
                this.butiran[i].amaun_debit;
                this.form.amaun =
                    this.form.amaun + parseFloat(this.butiran[i].amaun_debit);
            }
            this.baki(this.form);
        },

        cekJumlah() {
            this.form.baki_akhir =
                this.form.amaun_tunggakan - this.form.amaun_tambah_deposit;
            this.form.baki_akhir;
        },

        cekJumlah2() {
            this.form.baki_akhir =
                this.form.amaun_tunggakan + this.form.amaun_pembayar;
            this.form.baki_akhir;
        },

        cekJumlah3() {
            this.form.baki_akhir =
                this.form.amaun_tunggakan - this.form.amaun_transaksi;
            this.form.baki_akhir;
        },

        // baki(form) {
        //     var baki = form.amaun_belum_inbois;
        //     this.totalPelarasan(baki);
        // },
        baki(form) {
            if (form.lkp_tuntutan_bantuan_transaksi_id != 1) {
                var baki = form.amaun_tunggakan;
            } else {
                var baki = form.amaun_baki;
            }
            form.amaun_baki = baki - form.amaun;
        },

        cekBaki(form) {
            var bayar = form.amaun_tambah_deposit;
            this.cekAmaun2(bayar);
        },

        cekAmaun2(bayar) {
            var baki = this.form.amaun_baki;

            this.form.new_amaun_baki = parseFloat(baki) + parseFloat(bayar);
        },

        // reset() {
        //     this.form = {
        //         show: true,
        //     };
        // },

        clear() {
            this.getData();
            this.files = false;
            this.$nextTick(() => {
                this.files = true;
            });
        },

        back() {
            window.history.back();
        },

        cetak(id) {
            // window.location.href = this.service_bil_pelbagai+'api/inbois/cetak'+id;
            window.location.href =
                this.service_tunggakan + "tuntutan_bantuan/cetak/" + this.id;
        },

        //   cetakResit() {
        //       // alert(this.form.resit_id);;
        //       window.location.href = this.service_kutipan+'resit/cetak/'+this.form.resit_id;
        //   },
        getData() {
            var app = this;

            if (this.id) {
                if (this.id > 0) {
                    this.$zcomm
                        .get(
                            this.service_tunggakan +
                                "tuntutan_bantuan/" +
                                this.id +
                                "" +
                                window.location.search
                        )
                        .then((res) => {
                            this.form = res;
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                }
            }
        },
        addBayaran() {
            this.bayaran_lain_lain.push({
                bayaran_profil_id: null,
                bayaran_profil_keterangan: null,
                bayaran_lkp_bank_id: null,
                bayaran_no_akaun: null,
                bayaran_catatan: null,
                amaun_pembayar: null,
            });
        },
        removeBayaran(index) {
            this.bayaran_lain_lain.splice(index, 1);
        },
        profil(i_ind) {
            this.i_ind = i_ind;
            this.dialogProfil.show = 1;
        },
        cariProfil() {
            if (this.carian_profil.q.length > 1) {
                this.$zcomm
                    .post(
                        this.service_utiliti + "lookup/profil",
                        this.carian_profil,
                        {}
                    )
                    .then((res) => {
                        console.log(res);
                        this.profils = res;
                    });
            }
        },

        pilihProfil(bayaran_profil_keterangan) {
            this.bayaran_lain_lain[this.i_ind].bayaran_profil_keterangan =
                bayaran_profil_keterangan;
        },

        upload(id) {
            let formData = new FormData();
            formData.append("file", this.files[0].file);
            formData.append("model", "App\\Models\\TuntutanBantuan");
            formData.append("model_id", id);
            this.$zcomm
                .post(this.resourceurl + "/upload", formData)
                .then((res) => {
                    if (typeof this.onAfterAdd === "function") {
                        this.onAfterAdd();
                    }
                    this.$zutil.notify("Rekod telah berjaya dihantar");

                    this.getData();
                    this.activeTab = 0;
                    this.submitLoading = true;
                    this.$inertia.visit(this.route("bantuan.show"));
                    // this.$inertia.visit(this.$route('pendidikan.index'));
                })
                .catch((err) => {})
                .finally(() => {});
        },
        lampiran() {
            this.dialogLampiran.show = 1;
        },
        inactive() {
            this.dialog.show = 1;
        },
        addItem1() {
            this.butiran.push({ akaun_id: null, amaun_debit: 0.0 });
        },
    },
    watch: {},
    mounted() {
        this.getData();
        if (this.id == 0) {
            this.form = {
                show: true,
                bayaran_lain_lain: [
                    {
                        bayaran_profil_id: null,
                        bayaran_profil_keterangan: null,
                        bayaran_lkp_bank_id: null,
                        bayaran_no_akaun: null,
                        bayaran_catatan: null,
                        amaun_pembayar: null,
                    },
                ],
            };
        }
    },
};
</script>
